export const AdjustmentTypeOptionsValues = {
    Add: 'ADD',
};

export const AdjustmentTypeOptions = [
    { value: AdjustmentTypeOptionsValues.Add, label: 'Add Charge', className: 'fa-plus-circle text-success' },
    { value: AdjustmentTypeOptionsValues.Adjust, label: 'Adjust Charge', className: 'fa-minus-circle text-danger' },
];

export class TimesheetDetailsAdjustment {
    timesheetId = 0;

    chargeTypeName = '';

    chargeTypeId = 0;

    resourceName = '';

    resourceId = 0;

    resourceTypeId = 0;

    notes = '';

    jobDate = null;

    start = null;

    end = null;

    quantity = 0;

    unitsId = 0;

    unitsName = '';

    EmployeeId = 0;

    Loads = 0;

    MaterialId = 0;
}

export class TimesheetChargeAdjustment {
    timesheetId = 0;

    chargeTypeName = '';

    chargeTypeId = 0;

    chargeTypeObj = {
        resourceTypeId: 0,
        description: '',
        unitsId: 0,
        units: {
            description: '',
        }      
    }

    resourceName = '';

    resourceId = 0;

    resourceTypeId = 0;

    notes = '';

    jobDate = null;

    start = null;

    end = null;

    quantity = 0;

    unitsId = 0;

    unitsName = '';

    EmployeeId = 0;
}
